'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var framerMotion = require('framer-motion');
var toast_utils = require('./toast.utils.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var toastMotionVariants = {
  initial: function initial(props) {
    var position = props.position;
    var dir = ['top', 'bottom'].includes(position) ? 'y' : 'x';
    var factor = ['top-right', 'bottom-right'].includes(position) ? 1 : -1;
    if (position === 'bottom') factor = 1;
    return _defineProperty__default["default"]({
      opacity: 0
    }, dir, factor * 24);
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
};
var ToastComponent = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
    message = props.message,
    onCloseComplete = props.onCloseComplete,
    onRequestRemove = props.onRequestRemove,
    _props$requestClose = props.requestClose,
    requestClose = _props$requestClose === void 0 ? false : _props$requestClose,
    position = props.position,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 5000 : _props$duration,
    containerStyle = props.containerStyle,
    _props$motionVariants = props.motionVariants,
    motionVariants = _props$motionVariants === void 0 ? toastMotionVariants : _props$motionVariants,
    _props$toastSpacing = props.toastSpacing,
    toastSpacing = _props$toastSpacing === void 0 ? '0.5rem' : _props$toastSpacing;
  var _useState = React.useState(duration),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    delay = _useState2[0],
    setDelay = _useState2[1];
  var isPresent = framerMotion.useIsPresent();
  react.useUpdateEffect(function () {
    if (!isPresent) {
      onCloseComplete === null || onCloseComplete === void 0 ? void 0 : onCloseComplete();
    }
  }, [isPresent]);
  react.useUpdateEffect(function () {
    setDelay(duration);
  }, [duration]);
  var onMouseEnter = function onMouseEnter() {
    return setDelay(null);
  };
  var onMouseLeave = function onMouseLeave() {
    return setDelay(duration);
  };
  var close = function close() {
    if (isPresent) onRequestRemove();
  };
  React.useEffect(function () {
    if (isPresent && requestClose) {
      onRequestRemove();
    }
  }, [isPresent, requestClose, onRequestRemove]);
  react.useTimeout(close, delay);
  var containerStyles = React.useMemo(function () {
    return _objectSpread({
      pointerEvents: 'auto',
      maxWidth: 560,
      minWidth: 300,
      margin: toastSpacing
    }, containerStyle);
  }, [containerStyle, toastSpacing]);
  var toastStyle = React.useMemo(function () {
    return toast_utils.getToastStyle(position);
  }, [position]);
  return /*#__PURE__*/React__default["default"].createElement(framerMotion.motion.div, {
    layout: true,
    className: "chakra-toast",
    variants: motionVariants,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    onHoverStart: onMouseEnter,
    onHoverEnd: onMouseLeave,
    custom: {
      position: position
    },
    style: toastStyle
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    role: "status",
    "aria-atomic": "true",
    className: "chakra-toast__inner",
    __css: containerStyles
  }, utils.runIfFn(message, {
    id: id,
    onClose: close
  })));
});
ToastComponent.displayName = 'ToastComponent';
exports.ToastComponent = ToastComponent;